<template>
  <div>

    <p class="mb-10 mt-10" style="font-size: 25pt; text-align: center">
      PUBLICACIONES
    </p>

    <!-- <p class="mb-10" style="font-size: 20pt; text-align: center">
      Este es tú espacio de configuracion, aquí puedes registrar, editar y
      administrar: <br />
      Variables, Indices, Clima a Largo Plazo y crear Publicaciones.
    </p> -->

    <v-card outlined>
      <v-toolbar flat>
        <v-btn @click="irAtras" icon>
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>

        <v-toolbar-title class="grey--text"
          >{{ publicaciones.length }} Publicación (es)</v-toolbar-title
        >

        <v-spacer></v-spacer>

        <v-btn depressed color="primary" @click="irAgregarPublicacion()">
          <v-icon left dark> mdi-plus </v-icon>
          Agregar Publicación
        </v-btn>
      </v-toolbar>

      <v-divider></v-divider>

      <v-card-text>
        <v-row>
          <v-col cols="12" class="pa-0">
            <v-list v-if="publicaciones.length > 0" two-line subheader>
              <v-list-item v-for="item in publicaciones" :key="item.Name.es">
                <v-list-item-content>
                  <v-list-item-title>{{ item.Name.es }}</v-list-item-title>
                  <v-list-item-subtitle>
                    <p class="mb-0" style="line-height: 20px">
                      {{ item.Indices.length }} Indices -
                      {{ item.Variables.length }} Variables
                      <br />
                      {{ item.Id }}
                    </p>
                  </v-list-item-subtitle>
                </v-list-item-content>

                <v-list-item-action>
                  <v-menu bottom left>
                    <template v-slot:activator="{ on }">
                      <v-btn icon v-on="on">
                        <v-icon>mdi-dots-vertical</v-icon>
                      </v-btn>
                    </template>
                    <v-list dense>
                      <v-list-item @click="openDialogEditPublication(item)">
                        <v-list-item-icon class="mr-3">
                          <v-icon color="blue-grey">mdi-pencil-outline</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title>Editar</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item @click="redirectToComments(item.Id)">
                        <v-list-item-icon class="mr-3">
                          <v-icon>mdi-comment-text</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <span style= "font-size: 14px;">Ver comentarios</span>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item @click="deletePublication(item.Id)">
                        <v-list-item-icon class="mr-3">
                          <v-icon color="red">mdi-delete-outline</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title>Eliminar</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-list-item-action>
              </v-list-item>
            </v-list>
            <div v-else class="my-2 d-flex justify-center">
              <p style="font-size: 12pt" class="mb-0">
                No hay publiciones registradas, !Registra una!
              </p>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-dialog v-model="updatePublicationDialog">
      <v-card style="padding: 2rem">
        <v-form ref="formAddPublication">
          <v-row>
            <v-col cols="12">
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="newPublication.Name.es"
                    label="Titulo Publicación"
                    outlined
                    hide-details="auto"
                    required
                    :rules="rules"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="newPublication.Data.LinkImage"
                    label="Link Imagen"
                    outlined
                    placeholder="https://imagepublication.png"
                    hide-details="auto"
                    required
                    :rules="rules"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    v-model="newPublication.Introduction.es"
                    label="Introducción"
                    outlined
                    rows="3"
                    counter="550"
                    :rules="rules"
                  ></v-textarea>
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    v-model="newPublication.Data.InitialTitle.es"
                    label="Titulo Inicial"
                    outlined
                    hide-details="auto"
                    required
                    :rules="rules"
                  ></v-text-field>
                </v-col>

                <!-- CUERPO 1 -->
                <v-col class="pt-0" cols="12">
                  <p>Cuerpo de la Publicación:</p>
                  <div
                    class="editor"
                    style="border: 1px solid #000; border-radius: 4px"
                  >
                    <editor-menu-bar
                      class="pa-2"
                      :editor="editorAdd"
                      v-slot="{ commands, isActive }"
                      style="border-bottom: 1px solid #000"
                    >
                      <div class="menubar">
                        <button
                          class="menubar__button px-1"
                          :class="{ 'is-active': isActive.bold() }"
                          @click.prevent="commands.bold"
                        >
                          <span style="font-size: 14pt">
                            <b>B</b>
                          </span>
                        </button>

                        <button
                          class="menubar__button px-1"
                          :class="{
                            'is-active': isActive.heading({ level: 1 }),
                          }"
                          @click.prevent="commands.heading({ level: 1 })"
                        >
                          <span style="font-size: 14pt">
                            <b>H1</b>
                          </span>
                        </button>

                        <button
                          class="menubar__button px-1"
                          :class="{
                            'is-active': isActive.heading({ level: 2 }),
                          }"
                          @click.prevent="commands.heading({ level: 2 })"
                        >
                          <span style="font-size: 14pt">
                            <b>H2</b>
                          </span>
                        </button>

                        <button
                          class="menubar__button px-1"
                          :class="{
                            'is-active': isActive.heading({ level: 3 }),
                          }"
                          @click.prevent="commands.heading({ level: 3 })"
                        >
                          <span style="font-size: 14pt">
                            <b>H3</b>
                          </span>
                        </button>
                      </div>
                    </editor-menu-bar>
                    <editor-content
                      class="editor__content"
                      :editor="editorAdd"
                    />
                  </div>
                  <div class="ma-2">
                    <p class="text-right">
                      {{ countersTiptap.cuerpo1 }} / 2500
                    </p>
                  </div>
                </v-col>

                <!-- MANAGE ESCENARIOS CLIMATICOS -->
                <v-col class="pt-0">
                  <div
                    class="mb-2"
                    style="
                      display: flex;
                      align-items: center;
                      justify-content: space-between;
                    "
                  >
                    <div style="font-size: 15pt; font-weight: 600">
                      Agregar Escenarios Climáticos Largo Plazo 2050
                    </div>
                    <div>
                      <v-switch
                        v-model="newPublication.EscenariosClimaticos.Show"
                        inset
                        hide-details="auto"
                        class="mt-0"
                      ></v-switch>
                    </div>
                  </div>
                  <div v-show="newPublication.EscenariosClimaticos.Show">
                    <v-row>
                      <v-col>
                        <v-textarea
                          v-model="
                            newPublication.EscenariosClimaticos.BodyTemperatura
                              .es
                          "
                          label="Cuerpo Proyección Temperatura"
                          outlined
                          rows="3"
                          counter="550"
                        ></v-textarea>
                      </v-col>
                      <v-col>
                        <v-textarea
                          v-model="
                            newPublication.EscenariosClimaticos
                              .BodyPrecipitacion.es
                          "
                          label="Cuerpo Proyección Precipitación"
                          outlined
                          rows="3"
                          counter="550"
                        ></v-textarea>
                      </v-col>
                    </v-row>
                  </div>
                </v-col>

                <!-- INDICES -->
                <v-col cols="12">
                  <v-divider></v-divider>
                  <div class="mt-5">
                    <div class="d-flex justify-space-between align-center">
                      <div>
                        <p
                          class="mb-0"
                          style="font-size: 14pt; font-weight: 600"
                        >
                          Indices
                        </p>
                      </div>
                    </div>
                    <div style="padding: 1rem;">
                      <span style="font-size: 12pt; font-weight: 500; padding: 1rem"> Agrega máximo 3 indices para tu reporte</span>
                      <v-row>
                        <v-col cols="12" class="ml-2">
                          <div
                            v-for="indice in newPublication.Indices"
                            :key="indice.Id"
                          >
                            <div class='d-flex justify-space-between'>
                              <p class="mb-2" style="font-size: 14pt">
                              - {{ indice.Indice.Name.es }}
                              </p>
                              <v-btn @click="deleteIndicesFromPublication(indice)">
                                <v-icon>mdi-delete-outline</v-icon> Eliminar
                              </v-btn>
                            </div>
                            <div class="pl-2" v-html="indice.Body.es"></div>
                          </div>
                        </v-col>
                      </v-row>
                      <v-btn
                        @click="addIndicePublication = true"
                        outlined
                        color="indigo"
                        class="mt-5"
                      >
                        <v-icon left>mdi-plus</v-icon>Agregar Indice
                      </v-btn>
                    </div>     
                  </div>
                </v-col>
                <!-- VARIABLES -->
                <v-col>
                  <v-divider></v-divider>
                  <div class="mt-6">
                    <div class="d-flex justify-space-between align-center">
                      <div>
                        <p
                          class="mb-0"
                          style="font-size: 14pt; font-weight: 700"
                        >
                          Variables
                        </p>
                          <span style="font-size: 12pt; font-weight: 500"> Agrega máximo 3 variables para tu reporte</span>
                      </div>
                      <div>
                        <v-btn
                          @click="addVariablePublication = true"
                          outlined
                          color="indigo"
                        >
                          <v-icon left>mdi-plus</v-icon>Agregar Variable
                        </v-btn>
                      </div>
                    </div>
                    <v-row>
                      <v-col cols="12" class="ml-2">
                        <div
                          v-for="variable in newPublication.Variables"
                          :key="variable.Id"
                        >
                        <div class='d-flex justify-space-between'>
                              <p class="mb-2" style="font-size: 14pt">
                            - {{ variable.Variable.Name.es }}
                          </p>
                              <v-btn @click="deleteVariableFromPublication(variable)">
                                <v-icon>mdi-delete-outline</v-icon> Eliminar
                              </v-btn>
                            </div>
                          
                          <div class="pl-2" v-html="variable.Body.es"></div>
                        </div>
                      </v-col>
                    </v-row>
                  </div>
                </v-col>
                <v-col class="pt-0" cols="12">
                  <p>Cuerpo de la Publicación 2:</p>
                  <div
                    class="editor"
                    style="border: 1px solid #000; border-radius: 4px"
                  >
                    <editor-menu-bar
                      class="pa-2"
                      :editor="editorAdd2"
                      v-slot="{ commands, isActive }"
                      style="border-bottom: 1px solid #000"
                    >
                      <div class="menubar">
                        <button
                          class="menubar__button px-1"
                          :class="{ 'is-active': isActive.bold() }"
                          @click.prevent="commands.bold"
                        >
                          <span style="font-size: 14pt">
                            <b>B</b>
                          </span>
                        </button>

                        <button
                          class="menubar__button px-1"
                          :class="{
                            'is-active': isActive.heading({ level: 1 }),
                          }"
                          @click.prevent="commands.heading({ level: 1 })"
                        >
                          <span style="font-size: 14pt">
                            <b>H1</b>
                          </span>
                        </button>

                        <button
                          class="menubar__button px-1"
                          :class="{
                            'is-active': isActive.heading({ level: 2 }),
                          }"
                          @click.prevent="commands.heading({ level: 2 })"
                        >
                          <span style="font-size: 14pt">
                            <b>H2</b>
                          </span>
                        </button>

                        <button
                          class="menubar__button px-1"
                          :class="{
                            'is-active': isActive.heading({ level: 3 }),
                          }"
                          @click.prevent="commands.heading({ level: 3 })"
                        >
                          <span style="font-size: 14pt">
                            <b>H3</b>
                          </span>
                        </button>
                      </div>
                    </editor-menu-bar>
                    <editor-content
                      class="editor__content"
                      :editor="editorAdd2"
                    />
                  </div>
                  <div class="ma-2">
                    <p class="text-right">
                      {{ countersTiptap.cuerpo2 }} / 2500
                    </p>
                  </div>
                </v-col>

                <!-- PATROCINADORES -->
                <v-col cols="12">
                  <div class="mt-2">
                    <div class="d-flex justify-space-between align-center">
                      <div>
                        <p
                          class="mb-0"
                          style="font-size: 14pt; font-weight: 500"
                        >
                          Agregar Socios
                        </p>
                      </div>
                      <div>
                        <v-btn
                          @click="addSponsorPublication = true"
                          outlined
                          color="indigo"
                        >
                          <v-icon left>mdi-plus</v-icon>Agregar Socio
                        </v-btn>
                      </div>
                    </div>
                    <v-row>
                      <v-col cols="12" class="ml-2">
                        <div
                          v-for="sponsor in newPublication.Sponsors"
                          :key="sponsor.Id"
                        >
                          <p class="mb-2" style="font-size: 14pt">
                            {{ sponsor.Name }}
                          </p>
                          <div class="pl-2">
                            {{ sponsor.Data.description }}
                          </div>
                          <v-list-item @click="deleteSponsorFromPublication(sponsor)">
                            <v-list-item-icon class="mr-3">
                              <v-icon color="red">mdi-delete-outline</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title>Eliminar</v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </div>
                      </v-col>
                    </v-row>
                  </div>
                </v-col>
                <!-- BIBLIOGRAFIA -->
                <v-col cols="12">
                  <div class="mt-2">
                    <div class="d-flex justify-space-between align-center">
                      <div>
                        <p
                          class="mb-0"
                          style="font-size: 14pt; font-weight: 500"
                        >
                          Agregar Bibliografia
                        </p>
                      </div>
                      <div>
                        <v-btn
                          @click="showAddBibliografia = true"
                          outlined
                          color="indigo"
                        >
                          <v-icon left>mdi-plus</v-icon>Agregar Bibliografia
                        </v-btn>
                      </div>
                    </div>
                    <v-row>
                      <v-col cols="12" class="ml-2">
                        <div
                          v-for="bibliografia in newPublication.Bibliografias"
                          :key="bibliografia.Text"
                        >
                          <p class="mb-2" style="font-size: 14pt">
                            {{ bibliografia.Text }}
                          </p>
                        </div>
                      </v-col>
                    </v-row>
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <div class="my-3 mb-2 mt-6" style="display: flex; justify-content: center">
            <v-btn
              @click="updatePublication(newPublication)"
              dark
              x-large
              color="secondary"
            >
              Actualizar Publicación
            </v-btn>
          </div>
        </v-form>
      </v-card>
    </v-dialog>

    <v-dialog v-model="addIndicePublication" persistent max-width="700px">
      <v-card>
        <v-toolbar flat color="primary" dark>
          <v-toolbar-title>Agregar Indice Publicación</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="addIndicePublication = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pb-2 pt-2">
          <v-form ref="formAddIndicePublication">
            <v-row>
              <v-col cols="12">
                <v-select
                  v-model="newIndicePublicacion.Indice"
                  :items="formPublication.indices"
                  item-text="Name.es"
                  chips
                  label="Selecciona un Indice"
                  hide-details="auto"
                  outlined
                  return-object
                  :rules="rulesMultiple"
                ></v-select>
              </v-col>
              <v-col cols="12">
                <p>Cuerpo de Indice</p>
                <div
                  class="editor"
                  style="border: 1px solid #000; border-radius: 4px"
                >
                  <editor-menu-bar
                    class="pa-2"
                    :editor="editorAddIndice"
                    v-slot="{ commands, isActive }"
                    style="border-bottom: 1px solid #000"
                  >
                    <div class="menubar">
                      <button
                        class="menubar__button px-1"
                        :class="{ 'is-active': isActive.bold() }"
                        @click.prevent="commands.bold"
                      >
                        <span style="font-size: 14pt">
                          <b>B</b>
                        </span>
                      </button>

                      <button
                        class="menubar__button px-1"
                        :class="{ 'is-active': isActive.heading({ level: 1 }) }"
                        @click.prevent="commands.heading({ level: 1 })"
                      >
                        <span style="font-size: 14pt">
                          <b>H1</b>
                        </span>
                      </button>

                      <button
                        class="menubar__button px-1"
                        :class="{ 'is-active': isActive.heading({ level: 2 }) }"
                        @click.prevent="commands.heading({ level: 2 })"
                      >
                        <span style="font-size: 14pt">
                          <b>H2</b>
                        </span>
                      </button>

                      <button
                        class="menubar__button px-1"
                        :class="{ 'is-active': isActive.heading({ level: 3 }) }"
                        @click.prevent="commands.heading({ level: 3 })"
                      >
                        <span style="font-size: 14pt">
                          <b>H3</b>
                        </span>
                      </button>
                    </div>
                  </editor-menu-bar>
                  <editor-content
                    class="editor__content"
                    :editor="editorAddIndice"
                  />
                </div>
              </v-col>
              <v-col cols="12">
                <v-checkbox
                  class="mt-0"
                  v-model="newIndicePublicacion.Destacar"
                  label="¿Destacar este Indice?"
                  hide-details="auto"
                ></v-checkbox>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red darken-1"
            text
            large
            @click="cancelDialogAddIndicePublicacion()"
            >Cancelar</v-btn
          >
          <v-btn text @click="addIndicePublicacion(newIndicePublicacion)" large
            >Guardar</v-btn
          >
        </v-card-actions>
        <v-overlay :absolute="true" :value="loadingAddPublication">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
      </v-card>
    </v-dialog>

    <!-- AGREGAR VARIABLE PUBLICACION -->
    <v-dialog v-model="addVariablePublication" persistent max-width="700px">
      <v-card>
        <v-toolbar flat color="primary" dark>
          <v-toolbar-title>Agregar Variable Publicación</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="addVariablePublication = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pb-2 pt-2">
          <v-form ref="formAddVariablePublication">
            <v-row>
              <v-col cols="12">
                <v-select
                  v-model="newVariablePublicacion.Variable"
                  :items="formPublication.variables"
                  item-text="Name.es"
                  chips
                  label="Variables"
                  hide-details="auto"
                  outlined
                  return-object
                  :rules="rulesMultiple"
                ></v-select>
                <v-select
                    v-model="newVariablePublicacion.chartType"
                    :items="['Column', 'Line', 'Pie']"
                    item-text="Name"
                    chips
                    label="Tipos de grafica"
                    hide-details="auto"
                    outlined
                    return-object
                    style="margin-top:20px;"
                    :rules="rulesMultiple"
                ></v-select>
              </v-col>
              <v-col cols="12">
                <p>Cuerpo de Variable</p>
                <div
                  class="editor"
                  style="border: 1px solid #000; border-radius: 4px"
                >
                  <editor-menu-bar
                    class="pa-2"
                    :editor="editorAddVariable"
                    v-slot="{ commands, isActive }"
                    style="border-bottom: 1px solid #000"
                  >
                    <div class="menubar">
                      <button
                        class="menubar__button px-1"
                        :class="{ 'is-active': isActive.bold() }"
                        @click.prevent="commands.bold"
                      >
                        <span style="font-size: 14pt">
                          <b>B</b>
                        </span>
                      </button>

                      <button
                        class="menubar__button px-1"
                        :class="{ 'is-active': isActive.heading({ level: 1 }) }"
                        @click.prevent="commands.heading({ level: 1 })"
                      >
                        <span style="font-size: 14pt">
                          <b>H1</b>
                        </span>
                      </button>

                      <button
                        class="menubar__button px-1"
                        :class="{ 'is-active': isActive.heading({ level: 2 }) }"
                        @click.prevent="commands.heading({ level: 2 })"
                      >
                        <span style="font-size: 14pt">
                          <b>H2</b>
                        </span>
                      </button>

                      <button
                        class="menubar__button px-1"
                        :class="{ 'is-active': isActive.heading({ level: 3 }) }"
                        @click.prevent="commands.heading({ level: 3 })"
                      >
                        <span style="font-size: 14pt">
                          <b>H3</b>
                        </span>
                      </button>
                    </div>
                  </editor-menu-bar>
                  <editor-content
                    class="editor__content"
                    :editor="editorAddVariable"
                  />
                </div>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red darken-1"
            text
            large
            @click="cancelDialogAddVariablePublicacion()"
            >Cancelar</v-btn
          >
          <v-btn
            text
            @click="addVariablePublicacion(newVariablePublicacion)"
            large
            >Guardar</v-btn
          >
        </v-card-actions>
        <v-overlay :absolute="true" :value="loadingAddPublication">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
      </v-card>
    </v-dialog>
    <!-- AGREGAR BIBLIOGRAFIA PUBLICACION -->
    <v-dialog v-model="showAddBibliografia" persistent max-width="700px">
      <v-card>
        <v-toolbar flat color="primary" dark>
          <v-toolbar-title>Agregar Socio Publicación</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="showAddBibliografia = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <div style="padding: 1rem">
          <v-text-field
            class="mb-3"
            v-model="newBibliografia.Url"
            label="URL - la url debe estar completa (e.j: http://www.cultivandofuturo.com)"
            outlined
            hide-details="auto"
            required
            :rules="urlRule"
          ></v-text-field>
          <v-text-field
            v-model="newBibliografia.Text"
            label="Texto"
            outlined
            hide-details="auto"
            required
            :rules="rules"
          ></v-text-field>
        </div>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red darken-1"
            text
            large
            @click="cancelDialogAddSponsorPublicacion()"
            >Cancelar</v-btn
          >
          <v-btn
            text
            @click="addBiografiaPublicacion()"
            large
            >Guardar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- AGREGAR PATROCINADORES PUBLICACION -->
    <v-dialog v-model="addSponsorPublication" persistent max-width="700px">
      <v-card>
        <v-toolbar flat color="primary" dark>
          <v-toolbar-title>Agregar Socio Publicación</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="addSponsorPublication = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pb-2 pt-2">
          <v-form ref="formAddVariablePublication">
            <v-row>
              <v-col cols="12">
                <v-select
                  v-model="newSponsorPublication"
                  :items="formPublication.patrocinadores"
                  item-text="Name"
                  chips
                  label="Socios"
                  hide-details="auto"
                  outlined
                  return-object
                  :rules="rulesMultiple"
                ></v-select>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red darken-1"
            text
            large
            @click="showAddBibliografia= false"
            >Cancelar</v-btn
          >
          <v-btn
            text
            @click="addSponsorPublicacion()"
            large
            >Guardar</v-btn
          >
        </v-card-actions>
        <v-overlay :absolute="true" :value="loadingAddPublication">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="snackbar.show"
      bottom
      :color="snackbar.color"
      :timeout="5000"
      >{{ snackbar.text }}</v-snackbar
    >

    <v-overlay :value="loadingScreen">
      <v-progress-circular
        class="mb-4"
        indeterminate
        size="64"
      ></v-progress-circular>
      <p>Cargando...</p>
    </v-overlay>
  </div>
</template>

<script>
import api from "@/api/api";
import { Editor, EditorContent, EditorMenuBar } from "tiptap";
import { Heading, Bold } from "tiptap-extensions";

export default {
  name: "Home",
  components: {
    EditorContent,
    EditorMenuBar,
  },
  data() {
    return {
      publicaciones: [],
      showAddBibliografia: false,
      formPublication: {
        indices: [],
        variables: [],
        patrocinadores: [],
      },
      newPublication: {
        Name: {
          es: null,
        },
        Introduction: {
          es: null,
        },
        Body: {
          es: {
            First: null,
            Second: null,
          },
        },
        EscenariosClimaticos: {
          Show: false,
          BodyTemperatura: {
            es: null,
          },
          BodyPrecipitacion: {
            es: null,
          },
        },
        Indices: [],
        Variables: [],
        Data: {
          LinkImage: null,
          InitialTitle: {
            es: null,
          },
        },
        Sponsors: [],
        Bibliografias:[]
      },
      countersTiptap: {
        cuerpo1: 0,
        cuerpo2: 0,
      },
      newBibliografia:{
        Text: null,
        Url: null
      },
      addPublicationDialog: false,
      addIndicePublication: false,
      newSponsorPublication:{},
      addSponsorPublication: false,

      newIndicePublicacion: {
        Indice: null,
        Body: {
          es: null,
        },
        Destacar: false,
      },
      addVariablePublication: false,
      newVariablePublicacion: {
        Variable: null,
        Body: {
          es: null,
        },
      },
      rules: [(v) => !!v || "Este campo es requerido"],
      rulesMultiple: [
        (v) => {
          if (!v || v.length < 1) {
            return "Este campo es requerido";
          } else {
            return true;
          }
        },
      ],
      urlRule:[(v)=> {
        if (!v || v.length < 1) {
          return "Este campo es requerido";
        } else if (!/^(https?|ftp):\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i.test(v)){
          return "URL invalida"
        } else {
          return true;
        }
      }],
      loadingAddPublication: false,
      updatePublicationDialog: false,
      editorAdd: new Editor({
        extensions: [new Heading({ levels: [1, 2, 3] }), new Bold()],
        content: "",
        onUpdate: ({ getHTML }) => {
          this.newPublication.Body.es.First = getHTML();
        },
      }),
      editorAdd2: new Editor({
        extensions: [new Heading({ levels: [1, 2, 3] }), new Bold()],
        content: "",
        onUpdate: ({ getHTML }) => {
          this.newPublication.Body.es.Second = getHTML();
        },
      }),
      editorAddIndice: new Editor({
        extensions: [new Heading({ levels: [1, 2, 3] }), new Bold()],
        content: "",
        onUpdate: ({ getHTML }) => {
          this.newIndicePublicacion.Body.es = getHTML();
        },
      }),
      editorAddVariable: new Editor({
        extensions: [new Heading({ levels: [1, 2, 3] }), new Bold()],
        content: "",
        onUpdate: ({ getHTML }) => {
          this.newVariablePublicacion.Body.es = getHTML();
        },
      }),
      snackbar: {
        show: false,
        text: null,
        color: null,
      },
      loadingScreen: false,
    };
  },
  mounted() {
    this.getPublicaciones();
  },
  methods: {
    async getPublicaciones() {
      try {
        const data = await api.getPublicaciones();
        if (data.data.status) {
          this.publicaciones = data.data.data;
        }
      } catch (err) {
        console.log(err);
      }
    },
    async getIndices() {
      try {
        const data = await api.getIndices();

        if (data.status) {
          this.formPublication.indices = data.data;
        }
      } catch (err) {
        console.log(err);
      }
    },
    async getVariables() {
      try {
        const data = await api.getVariables();

        if (data.status) {
          this.formPublication.variables = data.data;
        }
      } catch (err) {
        console.log(err);
      }
    },
    openDialogAddPublication() {
      this.getIndices();
      this.getVariables();
      this.addPublicationDialog = true;
    },
    cancelDialogAddPublication() {
      this.addPublicationDialog = false;
    },
    addIndicePublicacion(data) {
      try {
        this.newPublication.Indices.push(data);
        this.newIndicePublicacion = {
          Indice: null,
          Body: {
            es: null,
          },
          Destacar: false,
        };
        this.editorAddIndice.clearContent();
        this.addIndicePublication = false;
      } catch (err) {
        console.log(err);
      }
    },
    cancelDialogAddIndicePublicacion() {
      this.addIndicePublication = false;
    },
    addVariablePublicacion(data) {
      try {
        this.newPublication.Variables.push(data);
        this.newVariablePublicacion = {
          Variable: null,
          Body: {
            es: null,
          },
        };
        this.editorAddVariable.clearContent();
        this.addVariablePublication = false;
      } catch (err) {
        console.log(err);
      }
    },
    cancelDialogAddVariablePublicacion() {
      this.addVariablePublication = false;
    },
    async updatePublication(newPublication) {
      try {
        if (this.$refs.formAddPublication.validate()) {
          this.loadingAddPublication = true;
          const data = await api.updatePublication(newPublication, newPublication.Id);
          if (data.status) {
            this.updatePublicationDialog = false;
            this.newPublication = {
              Name: {
                es: null,
              },
              Introduction: {
                es: null,
              },
              Body: {
                es: {
                  First: null,
                  Second: null,
                },
              },
              EscenariosClimaticos: {
                Show: false,
                BodyTemperatura: {
                  es: null,
                },
                BodyPrecipitacion: {
                  es: null,
                },
              },
              Indices: [],
              Variables: [],
              Data: {
                LinkImage: null,
                InitialTitle: {
                  es: null,
                },
              },
              Sponsors: [],
              Bibliografias:[]
            },
            this.editorAdd.clearContent();
            this.$refs.formAddPublication.reset();
            this.addPublicationDialog = false;
            this.getPublicaciones();
          }
        }
      } catch (err) {
        console.log(err);
      }
    },
    cancelDialogAddPublicacion() {
      this.$refs.formAddPublication.reset();
      this.addPublicationDialog = false;
    },
    deleteSponsorFromPublication(psponsor) {
      this.newPublication.Sponsors = this.newPublication.Sponsors.filter(sponsor => psponsor !== sponsor);
    },
    deleteVariableFromPublication(pvariable) {
      this.newPublication.Variables = this.newPublication.Variables.filter(variable => pvariable !== variable);
    },
    deleteIndicesFromPublication(pindice) {
      this.newPublication.Indices = this.newPublication.Indices.filter(indice => pindice !== indice);
    },
    openDialogEditPublication(item) {
      this.newPublication = item;
      this.getIndices();
      this.getVariables();
      this.getPatrocinadores();
      this.editorAdd.setContent(item.Body.es.First)
      this.editorAdd2.setContent(item.Body.es.Second)
      this.updatePublicationDialog = true;
    },
    cancelDialogEditPublication() {
      this.updatePublicationDialog = false;
    },
    async deletePublication(idPublication) {
      try {
        this.loadingScreen = true;
        let data = await api.deletePublication(idPublication);
        this.loadingScreen = false;
        this.showSnackbar("La publicación se eliminó correctamente", "success");
        this.getPublicaciones();
      } catch (err) {
        console.err(err);
      }
    },
    async getPatrocinadores() {
      try {
        this.loadingScreen = true;
        const data = await api.getPatrocinadores();
        if (data.data.status) {
          this.formPublication.patrocinadores = data.data.data;
        }
        this.loadingScreen = false;
      } catch (err) {
        console.log(err);
      }
    },
    addSponsorPublicacion() {
      try {
        this.newPublication.Sponsors.push(this.newSponsorPublication);
        this.addSponsorPublication = false;
        this.newSponsorPublication = null;
      } catch (err) {
        console.log(err);
      }
    },
    addBiografiaPublicacion() {
      try {
        this.newPublication.Bibliografias.push({...this.newBibliografia});
        this.showAddBibliografia = false;
        this.newBibliografia.Text = null;
        this.newBibliografia.Url = null;
      } catch (err) {
        console.log(err);
      }
    },
    showSnackbar(message, color) {
      this.snackbar.text = message;
      this.snackbar.color = color;
      this.snackbar.show = true;
    },
    irAgregarPublicacion() {
      this.$router.push("/admin/publicaciones/agregar");
    },
    irAtras() {
      this.$router.go(-1);
    },
    redirectToComments(id) {
      this.$router.push({ path: `/admin/publicaciones/${id}/comments` })
    }
  },
  beforeDestroy() {
    // Always destroy your editor instance when it's no longer needed
    if (this.editor) {
      this.editor.destroy();
    }
  },
};
</script>